<template>
  <div :class="eqDivClass">
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="finalColumnDefs"
      :show-side-bar="false"
      :row-data="rowData"
      :auto-fit-content="false"
      style="width:100%;height:200px;margin-bottom: 5px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div style="text-align: right;margin-bottom: 5px">
      <el-button type="primary" @click="add">{{ $t('SeaExport.Add') }}</el-button>&nbsp;
      <el-button type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
    </div>
  </div>
</template>

<script>

import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'PredictionBookingSeaEqDataGrid',
  components: { },
  props: {
    job: { type: Object, required: true },
    value: { type: Array, default: () => [] },
    isEdit: { type: Boolean, required: true }
  },
  data() {
    return {
      eqSizes: EQ_SIZES,
      eqTypes: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        suppressMenu: true,
        rowHeight: 32,
        unSortIcon: true,
        onCellFocused: (event) => {
          this.onUpCellFocused(event)
        },
        onRowClicked: this.rowClicked,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedSeaEQ: null, // 当前选中的记录
      eqDivClass: 'booking-sea-eq-data-grid'
    }
  },
  computed: {
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    fitSize() {
      return 90
    },
    finalColumnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: this.fitSize,
          suppressMenu: true,
          lockVisible: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              labelFunc: item => {
                return item.name
              },
              value: 'code',
              filterable: false
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.eqSizes] }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: this.fitSize,
          suppressMenu: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              labelFunc: item => {
                return item.code
              },
              value: 'code',
              filterable: true
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.eqTypes] },
              style: 'width:70px'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerAmount'),
          field: 'eqQuantity',
          width: this.fitSize,
          suppressMenu: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            min: 0,
            attrs: {
              style: 'width:65px'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: 'SOC',
          field: 'soc',
          suppressMenu: true,
          width: 50,
          hide: this.hideSoc,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-checkbox',
            valueChanged: p => { this.onCellChange(p) }
          }
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      this.rowData = newVal
      this.eqDivClass = 'prediction-booking-sea-eq-data-grid-si'
    },
    isEdit(newVal) {
      for (const item of this.finalColumnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEdit
        }
      }
    }
  },
  async created() {
    this.eqTypes = await getSpecificBasicData(basicCacheKeys.basic_data_EQType)
    this.rowData = this.value
    for (const item of this.finalColumnDefs) {
      if (item.custom instanceof Object) {
        item.custom.isEdit = this.isEdit
      }
    }
  },
  methods: {
    add() {
      let eqSize = ''
      if (this.rowData.length === 0) {
        eqSize = '20'
      } else {
        for (const item of this.eqSizes) {
          let isExist = false
          for (const subItem of this.rowData) {
            if (subItem.eqType === 'GP' && subItem.eqSize === item.code) {
              isExist = true
              break
            }
          }
          if (!isExist) {
            eqSize = item.code
            break
          }
        }
      }
      const row = new SeaEQ().fillDefaultValue().getData()
      row.eqSize = eqSize
      row.eqType = 'GP'
      row.eqQuantity = 1
      row.jobUuid = this.job.uuid
      this.rowData.push(row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
        this.gridApi.setFocusedCell(nodes.length - 1, 'eqSize')
        this.selectedSeaEQ = lastNode.data
      })
      this.job.seaEQ = this.rowData // 指向同一个 seaEQ
      // 装箱信息
      ContainerUtil.autoJustContainerUsages2(this.job)
    },
    remove() {
      if (!this.selectedSeaEQ) {
        return
      }
      if (this.selectedSeaEQ.containerNo || this.selectedSeaEQ.sealNo) {
        this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
        return
      }
      if (this.selectedSeaEQ.uuid) {
        this.selectedSeaEQ.deleted = true
        const index = this.rowData.findIndex(p => p.uuid === this.selectedSeaEQ.uuid)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
        if (!this.job.delseaEQUuids) {
          this.job.delseaEQUuids = []
        }
        this.job.delseaEQUuids.push(this.selectedSeaEQ.uuid)
      } else {
        const index = this.rowData.findIndex(p => p === this.selectedSeaEQ)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      this.job.seaEQ = this.rowData // 指向同一个 seaEQ
      // 更新装箱信息中的箱型信息
      ContainerUtil.autoJustContainerUsages(this.job)
      // 当 箱型数==0 时 autoJustContainerUsages 中没有移除最后的装箱信息
      if (this.job.lob === 'SI') {
        if (this.job.seaEQ && this.job.seaEQ.length === 0) {
          if (this.job.containers) {
            if (!this.job.delContainerUuids) {
              this.job.delContainerUuids = []
            }
            for (const container of this.job.containers) {
              this.job.delContainerUuids.push(container.uuid)
            }
            this.job.containers = []
            this.job.containerUsages = []
          }
        }
      }
    },
    onCellChange(params) {
      // 箱号 封号 大写
      if (params.field === 'sealNo' || params.field === 'containerNo') {
        if (params.value) {
          params.value = params.value.toUpperCase()
        }
      }
      // 装箱信息 （soc 编辑不影响container,usages 增删改）
      if (params.field !== 'soc') {
        if (this.job.masterFlag) {
          ContainerUtil.autoAdjustMasterContainer(this.job)
        } else {
          ContainerUtil.autoJustContainerUsages2(this.job)
        }
      }
      // soc状态改变
      if (params.field === 'soc') {
        if (this.job.containers) {
          for (const c of this.job.containers) {
            if (c.eqType === params.data.eqType && c.eqSize === params.data.eqSize && c.containerUsage &&
              c.sealNo === params.data.sealNo && c.containerNo === params.data.containerNo) {
              for (const usage of c.containerUsage) {
                usage.soc = params.data.soc
              }
            }
            c.isDirty = true
          }
        }
      }
    },
    rowClicked(event) {
      if (event) {
        this.selectedSeaEQ = event.data
      }
    },
    onUpCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            node.setSelected(true)
            this.selectedSeaEQ = node.data
          }
        })
      }
    },
    containerNbrStyleFunction(containerNo) {
      if (containerNo) {
        if (!ContainerNoHelper.checkContainerNo(containerNo)) {
          return 'data-red'
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.booking-sea-eq-data-grid {
  .ag-header-cell-text {
    color: #4283ff;
    font-weight: bold;
  }
}
prediction-booking-sea-eq-data-grid-si {
  .ag-header-cell-text {
    font-weight: bold;
  }
  .data-red {
     input.el-input__inner {
       color: #FF0000;
     }
   }
}
</style>
